// Domain
export const baseDomain = "http://" + process.env.REACT_APP_baseDomain;

// Email
export const infoEmail = process.env.REACT_APP_infoEmail;

// Image server
export const imageServer = "https://" + process.env.REACT_APP_baseImageDomain;
